import { qs, qsa } from "../inc/dom.js";

const initStories = () => {
    const grid = qs("[data-stories-grid]");
    if (!grid) return;
    const items = qsa("[data-t-item]", grid);
    if (!items.length) return;
    const limit = parseInt(grid.dataset.tLimit, 10) || items.length;
    const buttons = qsa("[data-t-filter]");
    const select = qs("[data-t-select]");
    const reveal = qs("[data-t-reveal]");
    const empty = qs("[data-t-empty]");

    let type = "";
    let expanded = false;

    const render = () => {
        let shown = 0;
        items.forEach((item) => {
            const matches = !type || item.dataset.tType === type;
            const capped = !expanded && !type && shown >= limit;
            const visible = matches && !capped;
            item.classList.toggle("is-hidden", !visible);
            if (matches) shown += 1;
        });
        buttons.forEach((button) => {
            button.classList.toggle("is-active", button.dataset.tFilter === type);
        });
        if (select && select.value !== type) select.value = type;
        if (empty) empty.hidden = shown !== 0;
        if (reveal) reveal.hidden = Boolean(type) || items.length <= limit;
    };

    buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();
            type = button.dataset.tFilter || "";
            render();
        });
    });

    if (select) {
        select.addEventListener("change", () => {
            type = select.value;
            render();
        });
    }

    if (reveal) {
        const label = qs(".reveal-label", reveal);
        reveal.addEventListener("click", () => {
            expanded = !expanded;
            reveal.classList.toggle("is-expanded", expanded);
            if (label) label.textContent = expanded ? "Show Less" : "View All Stories";
            render();
        });
    }

    render();
};

const initModals = () => {
    if (!window.bootstrap) return;
    qsa("[data-t-open]").forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            event.preventDefault();
            const target = document.getElementById(
                `testimonial-modal-${trigger.dataset.tOpen}`
            );
            if (target) window.bootstrap.Modal.getOrCreateInstance(target).show();
        });
    });
};

initStories();
initModals();
